import React from 'react';

import styles from './titleInner.module.scss'

const TitleInner = function(props) {
    const { title } = props

    return (
      <span className={styles.titleInner}>{title}</span>
    )
  }

export default React.memo(TitleInner)
